import {setShowUpdateModal} from './slice'
import {useDispatch,useSelector} from 'react-redux'
import SectionHeading from '../../sectionHeading/SectionHeading'
import Button from 'react-bootstrap/Button'
import {capitalize} from '../../../util/util'

const Billing = ()=>{
	const dispatch = useDispatch()

	const handleUpdateBilling = ()=>{
		dispatch(setShowUpdateModal(true))
	}

	const {billing_data:data} = useSelector(state=>state.users.current_user)

	return (
		<div>
			{
				data.payment_method_exists ?
				<div>
					<strong>Current {data.default.method_type==='card'?'card':'bank account'} on file</strong>: {capitalize(data.default.brand)} ({data.default.last4})
				</div>
				:
				<div>
					No card on file
				</div>
			}
			<Button 
				onClick={handleUpdateBilling}
				variant="outline-primary"
				size="sm"
			>
				Update Billing Info
			</Button>
			<div>
				<small>
					<i className="fa fa-info-circle"/> Billing info is required for purchasing subscriptions from trainers.
				</small>
			</div>
		</div>
	)
}


export default Billing


